export default __webpack_public_path__ + "static/media/frame-dialog.5bbc6d4b.png";